<template>
  <ToolTipAdvanced
    v-model="tooltipVisible"
    :custom-tooltip-classes="`${tooltipBoxTextColor} ${tooltipBoxBackground} ${tooltipBoxCustomClasses}`"
    :class="tooltipContainerClasses"
    :offset-x="tooltipOffsetX"
    :offset-y="tooltipOffsetY"
    :fixed="fixedPosition"
    @mouseenter="openTooltip"
    @mouseleave="closeTooltip">
    <template v-if="!customActivator" #activator>
      <IconWrapper
        :class="cursorType"
        :icon="icon"
        type="round"
        :fill="iconFill"
        :size="iconSize" />
    </template>
    <template v-else #activator>
      <slot name="activator" />
    </template>

    <template v-if="tooltipText" #content>{{ tooltipText }}</template>
    <template v-else #content><slot name="content" /></template>
  </ToolTipAdvanced>
</template>

<script setup>
import IconWrapper from '../../stories/IconWrapper/IconWrapper.vue';
import ToolTipAdvanced from '../../stories/toolTipAdvanced/ToolTipAdvanced.vue';
import { ref } from 'vue';

const props = defineProps({
  tooltipText: String,
  tooltipContainerClasses: String,
  iconSize: {
    type: Number,
    default: 24,
  },
  tooltipBoxBackground: {
    type: String,
    default: 'bg-button-primary-default-color1',
  },
  tooltipBoxTextColor: {
    type: String,
    default: 'text-inverted-color1',
  },
  tooltipBoxCustomClasses: {
    type: String,
    default: 'p-2 w-[280px] rounded mr-1',
  },
  icon: {
    type: String,
    default: 'info',
  },
  iconFill: {
    type: String,
    default: 'text-button-primary-default-neutral',
  },
  tooltipOffsetY: {
    type: Number,
    default: -20,
  },
  tooltipOffsetX: {
    type: Number,
    default: -160,
  },
  cursorType: {
    type: String,
    default: 'cursor-default',
  },
  customActivator: {
    type: Boolean,
    default: false,
  },
  fixedPosition: {
    type: String,
    default: null,
    validator: (value) => ['x', 'y', 'all', null].includes(value),
  },
});

const tooltipVisible = ref(false);

function openTooltip() {
  tooltipVisible.value = true;
}

function closeTooltip() {
  tooltipVisible.value = false;
}
</script>
